import IconChevronDown from "@components/ui/icons/IconChevronDown"
import { Span } from "@components/ui/typograhpy/Span"
import { Currency } from "@generated"
import { cn } from "@lib/cn"
import React from "react"

const getSymbol = (code: Currency) => {
  switch (code) {
    case Currency.Eur:
      return "€"
    case Currency.Usd:
      return "$"
    default:
      return ""
  }
}

type NavbarCurrencyButtonProps = {
  currency: Currency
}

export const NavbarCurrencyButton = React.forwardRef<
  HTMLButtonElement,
  NavbarCurrencyButtonProps & React.ButtonHTMLAttributes<HTMLButtonElement>
>(({ currency, className, ...rest }, ref) => {
  const symbol = getSymbol(currency)
  const label = `${symbol} ${currency}`

  return (
    <button
      {...rest}
      className={cn(
        "group bg-background relative flex h-8 items-center justify-center rounded-2xl px-3 text-sm font-semibold",
        "z-1 overflow-visible transition-[border_background_color_box-shadow_transform] duration-150",
        "after:bg-default after:absolute after:-top-px after:-left-px after:block after:h-[calc(100%+2px)] after:w-[calc(100%+2px)] after:-translate-z-px after:rounded-[18px] after:content-['']",
        `before:bg-default before:absolute before:top-0 before:left-3 before:block before:bg-clip-text before:leading-[33px] before:text-transparent before:content-[attr(data-content)]`,
        "focus-visible:shadow-focus-visible focus-visible:outline-0 active:scale-[0.98]",
      )}
      style={{ transformStyle: "preserve-3d" }}
      data-content={label}
      ref={ref}
    >
      <span
        className={cn(
          "absolute left-0 z-1 h-8 w-full opacity-0",
          "after:bg-hover after:absolute after:-top-px after:-left-px after:block after:h-[calc(100%+2px)] after:w-[calc(100%+2px)] after:-translate-z-px after:rounded-[18px] after:transition-[clip-path] after:duration-150 after:content-['']",
          "before:bg-hover before:absolute before:top-0 before:left-3 before:block before:translate-z-px before:bg-clip-text before:leading-[33px] before:text-transparent before:transition-[clip-path] before:duration-150 before:content-[attr(data-content)]",
          "group-hover:before:clip-path-polygon group-hover:opacity-100",
        )}
        style={{ transformStyle: "preserve-3d" }}
        data-gradient-hover
        data-content={label}
      />
      <Span
        data-testid="credits-remaining-label"
        variant="button-label-small"
        className="invisible block text-white"
      >
        {label}
      </Span>
      <IconChevronDown
        data-chevron
        size={12}
        className="text-variant-purple mt-[2px] ml-1"
      />
    </button>
  )
})

NavbarCurrencyButton.displayName = "NavbarCurrencyButton"
